import React from 'react'
import debounce from 'debounce'
import { _getEnterpriseCustomers } from '../../../services'

import {
  Table,
  Input
} from 'antd'
import moment from 'moment'

class EnterpriseContractTable extends React.Component {

  state = {
    searchParam: '',
    page: 1, 
    total: 0,
    pageSize: 10,
    customers: [],
    loading: false
  }

  render(){
    return (
      <div>
        <div>
          <Input
            placeholder={this.props.allEnterpriseFlag? "Search Supplier Name" : "Search Supplier / Enterprise Name"}
            onChange={this.handleInputChange}
            style={{ width: 400, marginBottom: 16 }}
          />  
        </div>
        <Table
          loading={this.state.loading}
          columns={this.getColumns()}
          dataSource={this.state.customers}
          pagination={{
            pageSize: this.state.pageSize,
            current: this.state.page,
            total: this.state.total,
            onChange: (nextPage) => this.setState({ page: nextPage }, this.getEnterpriseCustomers)
          }}
        />
      </div>
    )
  }

  async componentDidMount(){
    this.handleSearch = debounce(this.handleSearch, 400)
    await this.getEnterpriseCustomers()
  }

  getEnterpriseCustomers = async () => {

    this.setState({ loading: true })

    const {
      searchParam,
      page,
      pageSize
    } = this.state
    const res = await _getEnterpriseCustomers(searchParam, page, pageSize, this.props.allEnterpriseFlag)
    const {
      customers,
      total
    } = res.data

    this.setState({
      customers,
      total,
      loading: false
    })
  }

  handleInputChange = (e) => {
    this.handleSearch(e.target.value)
  }

  handleSearch = (searchParam) => {
    this.setState({
      searchParam,
      page: 1
    }, this.getEnterpriseCustomers)
  }

  getColumns = () => {
    const columns = [{
      title: 'Supplier',
      dataIndex: 'supplierName'
    },{
      title: 'Date Created',
      dataIndex: 'dateCreated',
      render: (dateCreated) => {
        return moment(dateCreated).format("DD/MM/YYYY")
      }
    },{
      title: "Actions",
      dataIndex: '_id',
      render: (customerId) => {
        return (<a
          target="_blank"
          href={`/enterprise/contracts/${customerId}`}
        >View</a>)
      }
    }]

    if (!this.props.allEnterpriseFlag) {
      columns.unshift({
        title: 'Require Enterprise Approval',
        dataIndex: 'requireEnterpriseApproval',
        render: (requireEnterpriseApproval) => requireEnterpriseApproval ? 'True' : ''
      })
    } 

    if (!this.props.allEnterpriseFlag) {
      columns.unshift({
        title: 'Enterprise',
        dataIndex: 'enterpriseName'
      })
    } 

    return columns
  }
}

export default EnterpriseContractTable 


// WEBPACK FOOTER //
// ./src/components/enterprise/contract/table.js